import {
  LayoutAuth,
  LayoutNewUser,
  LayoutDefault,
  RouteWrapper
} from '@/components/layouts'

export const publicRoute = [
  {
    path: '*',
    redirect: '/'
  },

  {
    path: '/login',
    redirect: '/auth/login'
  },

  {
    path: '/auth',
    component: LayoutAuth,
    meta: {
      title: 'Login'
    },
    redirect: '/auth/login',
    hidden: true,
    children: [
      {
        path: '/auth/login',
        name: 'login',
        meta: {
          title: 'Login'
        },
        component: () => import('@/views/auth/Login.vue')
      }
    ]
  },

  {
    path: '/manual',
    redirect: '/newuser/manual'
  },

  {
    path: '/exam',
    redirect: '/newuser/exam'
  },

  {
    path: '/newuser',
    component: LayoutNewUser,
    meta: {
      title: 'New User'
    },
    redirect: '/newuser/exam',
    hidden: true,
    children: [
      {
        path: '/newuser/exam',
        name: 'exam',
        meta: {
          title: 'Exam'
        },
        component: () => import('@/views/newuser/Exam.vue')
      },
      {
        path: '/newuser/manual',
        name: 'manual',
        meta: {
          title: 'Manual'
        },
        component: () => import('@/views/newuser/Manual.vue')
      },
    ]
  },

  {
    path: '/404',
    name: '404',
    meta: {
      title: 'Not Found'
    },
    component: () => import('@/views/error/NotFound.vue')
  },

  {
    path: '/500',
    name: '500',
    meta: {
      title: 'Server Error'
    },
    component: () => import('@/views/error/Error.vue')
  }
]

export const protectedRoute = [
  {
    // Root
    path: '/',
    component: LayoutDefault,
    meta: {
      title: 'home',
      group: 'apps',
      icon: ''
    },
    redirect: '/dashboard',
    children: [
      {
        // Dashboard (LF, Dealers, Clients)
        path: '/dashboard',
        name: 'dashboard',
        meta: {
          title: 'dashboard',
          group: 'apps',
          icon: 'mdi-view-dashboard-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN', 'ROLE_CLIENT']
        },
        component: () => import('@/views/Dashboard.vue')
      },

      {
        // Dealers Root (LF)
        path: '/dealers',
        name: 'dealers',
        meta: {
          title: 'dealers',
          icon: 'mdi-office-building-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING'],
        },
        component: () => import('@/views/companies/Dealers.vue'),
      },

      {
        // Dealers (LF)
        path: '/dealers',
        meta: {
          title: 'dealers',
          icon: 'mdi-office-building-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING'],
          hiddenInMenu: true
        },
        component: RouteWrapper,
        children: [
          {
            // Dealer Locations (LF)
            path: '/dealers/locations',
            name: 'locations',
            meta: {
              title: 'locations',
              icon: 'mdi-store-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
            },
            component: () => import('@/views/companies/Locations.vue'),
          },

          {
            // Dealer Clients (LF)
            path: '/dealers/clients',
            meta: {
              title: 'clients',
              icon: 'mdi-warehouse',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN'],
            },
            component: () => import('@/views/companies/Clients.vue'),
          },

          {
            // Dealer Lols (LF)
            path: '/dealers/lols',
            name: 'lols',
            meta: {
              title: 'lols',
              icon: 'mdi-tablet-cellphone',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
            },
            component: () => import('@/views/lols/Lols.vue'),
          },

          {
            // Dealer Certificates (LF)
            path: '/dealers/certificates',
            name: 'certificates',
            meta: {
              title: 'certificates',
              icon: 'mdi-certificate-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
            },
            component: () => import('@/views/lols/Certificates.vue')
          },

          {
            // Dealer Schedule (LF)
            path: '/dealers/schedule',
            name: 'schedule',
            meta: {
              title: 'schedule',
              icon: 'mdi-calendar-month-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
            },
            component: () => import('@/views/lols/Schedule.vue')
          },

          {
            // Dealer Users (LF)
            path: '/dealers/users',
            name: 'users',
            meta: {
              title: 'users',
              icon: 'mdi-account-group-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
            },
            component: () => import('@/views/companies/Users.vue')
          },
        ]
      },

      {
        // Dealers / Locations (LF)
        path: '/dealers',
        meta: {
          title: 'dealers',
          icon: 'mdi-office-building-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING'],
          hiddenInMenu: true
        },
        component: RouteWrapper,
        children: [
          {
            // Dealer Locations (LF)
            path: '/dealers/locations',
            meta: {
              title: 'locations',
              icon: 'mdi-store-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
            },
            component: RouteWrapper,
            children: [
              {
                // Dealer Locations Lols (LF)
                path: '/dealers/locations/lols',
                name: 'lols',
                meta: {
                  title: 'lols',
                  icon: 'mdi-tablet-cellphone',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
                },
                component: () => import('@/views/lols/Lols.vue'),
              },

              {
                // Dealer Locations Certificates (LF)
                path: '/dealers/locations/certificates',
                name: 'certificates',
                meta: {
                  title: 'certificates',
                  icon: 'mdi-certificate-outline',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
                },
                component: () => import('@/views/lols/Certificates.vue')
              },

              {
                // Dealer Locations Schedule (LF)
                path: '/dealers/locations/schedule',
                name: 'schedule',
                meta: {
                  title: 'schedule',
                  icon: 'mdi-calendar-month-outline',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
                },
                component: () => import('@/views/lols/Schedule.vue')
              },
            ]
          }
        ]
      },

      {
        // Dealers / Locations / Lols (LF)
        path: '/dealers',
        meta: {
          title: 'dealers',
          icon: 'mdi-office-building-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING'],
          hiddenInMenu: true
        },
        component: RouteWrapper,
        children: [
          {
            // Dealer Locations (LF)
            path: '/dealers/locations',
            meta: {
              title: 'locations',
              icon: 'mdi-store-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
            },
            component: RouteWrapper,
            children: [
              {
                // Dealer Lols (LF)
                path: '/dealers/locations/lols',
                meta: {
                  title: 'lols',
                  icon: 'mdi-tablet-cellphone',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
                },
                component: RouteWrapper,
                children: [
                  {
                    // Dealer Lols Certificates (LF)
                    path: '/dealers/locations/lols/certificates',
                    name: 'certificates',
                    meta: {
                      title: 'certificates',
                      icon: 'mdi-certificate-outline',
                      authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
                    },
                    component: () => import('@/views/lols/Certificates.vue')
                  },

                  {
                    // Lol Calibrations (LF, Dealer)
                    path: '/dealers/locations/lols/calibrations',
                    name: 'calibrations',
                    meta: {
                      title: 'calibrations',
                      icon: 'mdi-certificate-outline',
                      authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
                    },
                    component: () => import('@/views/lols/Calibrations.vue')
                  }
                ]
              },
            ]
          }
        ]
      },

      {
        // Dealers / Clients (LF)
        path: '/dealers',
        meta: {
          title: 'dealers',
          icon: 'mdi-office-building-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING'],
          hiddenInMenu: true
        },
        component: RouteWrapper,
        children: [
          {
            // Dealer Clients (LF, Dealers)
            path: '/dealers/clients',
            meta: {
              title: 'clients',
              icon: 'mdi-warehouse',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN'],
              hiddenInMenu: true
            },
            component: RouteWrapper,
            children: [
              {
                // Dealer Client Locations (LF, Dealers)
                path: '/dealers/clients/locations',
                name: 'locations',
                meta: {
                  title: 'locations',
                  icon: 'mdi-store-outline',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                },
                component: () => import('@/views/companies/Locations.vue'),
              },

              {
                // Dealer Clients Certificates (LF, Dealers)
                path: '/dealers/clients/certificates',
                name: 'certificates',
                meta: {
                  title: 'certificates',
                  icon: 'mdi-certificate-outline',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                },
                component: () => import('@/views/lols/Certificates.vue')
              },

              {
                // Dealer Clients Schedule (LF, Dealers)
                path: '/dealers/clients/schedule',
                name: 'schedule',
                meta: {
                  title: 'schedule',
                  icon: 'mdi-calendar-month-outline',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                },
                component: () => import('@/views/lols/Schedule.vue')
              },

              {
                // Dealer Client Users (LF, Dealers)
                path: '/dealers/clients/users',
                name: 'users',
                meta: {
                  title: 'users',
                  icon: 'mdi-account-group-outline',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                },
                component: () => import('@/views/companies/Users.vue')
              },
            ]
          },
        ]
      },

      {
        // Dealers / Clients / Locations (LF)
        path: '/dealers',
        meta: {
          title: 'dealers',
          icon: 'mdi-office-building-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING'],
          hiddenInMenu: true
        },
        component: RouteWrapper,
        children: [
          {
            // Dealers / Clients / Locations (LF, Dealers)
            path: '/dealers/clients',
            meta: {
              title: 'clients',
              icon: 'mdi-warehouse',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN'],
              hiddenInMenu: true
            },
            component: RouteWrapper,
            children: [
              {
                // Dealer Client Locations (LF, Dealers)
                path: '/dealers/clients/locations',
                meta: {
                  title: 'locations',
                  icon: 'mdi-store-outline',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                },
                component: RouteWrapper,
                children: [
                  {
                    // Dealer Client Location Sources (LF, Dealers)
                    path: '/dealers/clients/locations/sources',
                    name: 'air sources',
                    meta: {
                      title: 'air sources',
                      icon: 'mdi-cloud-outline',
                      authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                    },
                    component: () => import('@/views/companies/Sources.vue'),
                  },

                  {
                    // Dealer Client Location Certificates (LF, Dealers)
                    path: '/dealers/clients/locations/certificates',
                    name: 'certificates',
                    meta: {
                      title: 'certificates',
                      icon: 'mdi-certificate-outline',
                      authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                    },
                    component: () => import('@/views/lols/Certificates.vue')
                  },

                  {
                    // Dealer Client Location Schedule (LF, Dealers)
                    path: '/dealers/clients/locations/schedule',
                    name: 'schedule',
                    meta: {
                      title: 'schedule',
                      icon: 'mdi-calendar-month-outline',
                      authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                    },
                    component: () => import('@/views/lols/Schedule.vue')
                  },
                ]
              }
            ]
          },
        ]
      },

      {
        // Dealers / Clients / Locations / Sources (LF)
        path: '/dealers',
        meta: {
          title: 'dealers',
          icon: 'mdi-office-building-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING'],
          hiddenInMenu: true
        },
        component: RouteWrapper,
        children: [
          {
            // Dealers / Clients / Locations/ Sources (LF, Dealers)
            path: '/dealers/clients',
            meta: {
              title: 'clients',
              icon: 'mdi-warehouse',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN'],
              hiddenInMenu: true
            },
            component: RouteWrapper,
            children: [
              {
                // Dealer Client Locations (LF, Dealers)
                path: '/dealers/clients/locations',
                meta: {
                  title: 'locations',
                  icon: 'mdi-store-outline',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                },
                component: RouteWrapper,
                children: [
                  {
                    // Dealer Client Location Sources (LF, Dealers)
                    path: '/dealers/clients/locations/sources',
                    meta: {
                      title: 'air sources',
                      icon: 'mdi-cloud-outline',
                      authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                    },
                    component: RouteWrapper,
                    children: [
                      {
                        // Dealer Client Location Sources Certificates (LF, Dealers)
                        path: '/dealers/clients/locations/sources/certificates',
                        name: 'certificates',
                        meta: {
                          title: 'certificates',
                          icon: 'mdi-certificate-outline',
                          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                        },
                        component: () => import('@/views/lols/Certificates.vue')
                      },

                      {
                        // Dealer Client Location Sources Schedule (LF, Dealers)
                        path: '/dealers/clients/locations/sources/schedule',
                        name: 'schedule',
                        meta: {
                          title: 'schedule',
                          icon: 'mdi-calendar-month-outline',
                          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                        },
                        component: () => import('@/views/lols/Schedule.vue')
                      },
                    ]
                  }
                ]
              }
            ]
          },
        ]
      },

      {
        // Dealers / Lols (LF)
        path: '/dealers',
        meta: {
          title: 'dealers',
          icon: 'mdi-office-building-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING'],
          hiddenInMenu: true
        },
        component: RouteWrapper,
        children: [
          {
            // Dealer Lols (LF)
            path: '/dealers/lols',
            meta: {
              title: 'lols',
              icon: 'mdi-tablet-cellphone',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
            },
            component: RouteWrapper,
            children: [
              {
                // Dealer Lol Certificates (LF)
                path: '/dealers/lols/certificates',
                name: 'certificates',
                meta: {
                  title: 'certificates',
                  icon: 'mdi-certificate-outline',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
                },
                component: () => import('@/views/lols/Certificates.vue'),
              },
              {
                // Dealer Lol Calibrations (LF)
                path: '/dealers/lols/calibrations',
                name: 'calibrations',
                meta: {
                  title: 'calibrations',
                  icon: 'mdi-wrench-outline',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
                },
                component: () => import('@/views/lols/Calibrations.vue'),
              },
            ]
          }
        ]
      },

      {
        // Dealer/Client Locations Root (Dealers, Clients)
        path: '/locations',
        name: 'locations',
        meta: {
          title: 'my locations',
          icon: 'mdi-store-outline',
          authorize: ['ROLE_DEALERADMIN', 'ROLE_CLIENT']
        },
        component: () => import('@/views/companies/Locations.vue'),
      },

      {
        // Dealer/Client Locations (Dealers, Clients)
        path: '/locations',
        meta: {
          title: 'locations',
          icon: 'mdi-store-outline',
          authorize: ['ROLE_DEALERADMIN', 'ROLE_CLIENT'],
          hiddenInMenu: true
        },
        component: RouteWrapper,
        children: [
          {
            // Dealer Location Lols (Dealer)
            path: '/locations/lols',
            name: 'lols',
            meta: {
              title: 'lols',
              icon: 'mdi-tablet-cellphone',
              authorize: ['ROLE_DEALERADMIN']
            },
            component: () => import('@/views/lols/Lols.vue'),
          },

          {
            // Client Location Sources (Clients)
            path: '/locations/sources',
            name: 'air sources',
            meta: {
              title: 'air sources',
              icon: 'mdi-cloud-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_CLIENT']
            },
            component: () => import('@/views/companies/Sources.vue'),
          },

          {
            // Dealer/Client Location Certificates (Dealers, CLients)
            path: '/locations/certificates',
            name: 'certificates',
            meta: {
              title: 'certificates',
              icon: 'mdi-certificate-outline',
              authorize: ['ROLE_DEALERADMIN', 'ROLE_CLIENT']
            },
            component: () => import('@/views/lols/Certificates.vue')
          },

          {
            // Dealer/CLient Location Schedule (Dealers, Clients)
            path: '/locations/schedule',
            name: 'schedule',
            meta: {
              title: 'schedule',
              icon: 'mdi-calendar-month-outline',
              authorize: ['ROLE_DEALERADMIN', 'ROLE_CLIENT']
            },
            component: () => import('@/views/lols/Schedule.vue')
          },
        ]
      },

      {
        // Dealer Locations / Lols (Dealers, Clients)
        path: '/locations',
        meta: {
          title: 'locations',
          icon: 'mdi-store-outline',
          authorize: ['ROLE_DEALERADMIN', 'ROLE_CLIENT'],
          hiddenInMenu: true
        },
        component: RouteWrapper,
        children: [
          {
            // Dealer Location Lols (Dealer)
            path: '/locations/lols',
            meta: {
              title: 'lols',
              icon: 'mdi-tablet-cellphone',
              authorize: ['ROLE_DEALERADMIN']
            },
            component: RouteWrapper,
            children: [
              {
                // Dealer Location Lol Certificates (Dealer)
                path: '/locations/lols/certificates',
                name: 'certificates',
                meta: {
                  title: 'certificates',
                  icon: 'mdi-certificate-outline',
                  authorize: ['ROLE_DEALERADMIN']
                },
                component: () => import('@/views/lols/Certificates.vue')
              }
            ]
          }
        ]
      },

      {
        // Dealer/Client Locations / Sources (Dealers, Clients)
        path: '/locations',
        meta: {
          title: 'locations',
          icon: 'mdi-store-outline',
          authorize: ['ROLE_DEALERADMIN', 'ROLE_CLIENT'],
          hiddenInMenu: true
        },
        component: RouteWrapper,
        children: [
          {
            // Client Location Sources (Clients)
            path: '/locations/sources',
            meta: {
              title: 'air sources',
              icon: 'mdi-cloud-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
            },
            component: RouteWrapper,
            children: [
              {
                // Client Location Sources Certificates (Clients)
                path: '/locations/sources/certificates',
                name: 'certificates',
                meta: {
                  title: 'certificates',
                  icon: 'mdi-certificate-outline',
                  authorize: ['ROLE_CLIENT']
                },
                component: () => import('@/views/lols/Certificates.vue')
              },

              {
                // Client Location Sources Schedule (Clients)
                path: '/locations/sources/schedule',
                name: 'schedule',
                meta: {
                  title: 'schedule',
                  icon: 'mdi-calendar-month-outline',
                  authorize: ['ROLE_CLIENT']
                },
                component: () => import('@/views/lols/Schedule.vue')
              },
            ]
          },
        ]
      },

      {
        // Clients Root (LF, Dealers)
        path: '/clients',
        name: 'clients',
        meta: {
          title: 'clients',
          icon: 'mdi-warehouse',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN'],
        },
        component: () => import('@/views/companies/Clients.vue'),
      },

      {
        // Clients (LF, Dealers)
        path: '/clients',
        meta: {
          title: 'clients',
          icon: 'mdi-warehouse',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN'],
          hiddenInMenu: true
        },
        component: RouteWrapper,
        children: [
          {
            // Client Locations (LF, Dealers)
            path: '/clients/locations',
            name: 'locations',
            meta: {
              title: 'locations',
              icon: 'mdi-store-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
            },
            component: () => import('@/views/companies/Locations.vue'),
          },

          {
            // Clients Certificates (LF, Dealers)
            path: '/clients/certificates',
            name: 'certificates',
            meta: {
              title: 'certificates',
              icon: 'mdi-certificate-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
            },
            component: () => import('@/views/lols/Certificates.vue')
          },

          {
            // Clients Schedule (LF, Dealers)
            path: '/clients/schedule',
            name: 'schedule',
            meta: {
              title: 'schedule',
              icon: 'mdi-calendar-month-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
            },
            component: () => import('@/views/lols/Schedule.vue')
          },

          {
            // Client Users (LF, Dealers)
            path: '/clients/users',
            name: 'users',
            meta: {
              title: 'users',
              icon: 'mdi-account-group-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
            },
            component: () => import('@/views/companies/Users.vue')
          },
        ]
      },

      {
        // Clients / Locations (LF, Dealers)
        path: '/clients',
        meta: {
          title: 'clients',
          icon: 'mdi-warehouse',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN'],
          hiddenInMenu: true
        },
        component: RouteWrapper,
        children: [
          {
            // Client Locations (LF, Dealers)
            path: '/clients/locations',
            meta: {
              title: 'locations',
              icon: 'mdi-store-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
            },
            component: RouteWrapper,
            children: [
              {
                // Client Location Sources (LF, Dealers)
                path: '/clients/locations/sources',
                name: 'air sources',
                meta: {
                  title: 'air sources',
                  icon: 'mdi-cloud-outline',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                },
                component: () => import('@/views/companies/Sources.vue'),
              },

              {
                // Client Location Certificates (LF, Dealers)
                path: '/clients/locations/certificates',
                name: 'certificates',
                meta: {
                  title: 'certificates',
                  icon: 'mdi-certificate-outline',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                },
                component: () => import('@/views/lols/Certificates.vue')
              },

              {
                // Client Location Schedule (LF, Dealers)
                path: '/clients/locations/schedule',
                name: 'schedule',
                meta: {
                  title: 'schedule',
                  icon: 'mdi-calendar-month-outline',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                },
                component: () => import('@/views/lols/Schedule.vue')
              },
            ]
          }
        ]
      },

      {
        // Clients / Locations/ Sources (LF, Dealers)
        path: '/clients',
        meta: {
          title: 'clients',
          icon: 'mdi-warehouse',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN'],
          hiddenInMenu: true
        },
        component: RouteWrapper,
        children: [
          {
            // Client Locations (LF, Dealers)
            path: '/clients/locations',
            meta: {
              title: 'locations',
              icon: 'mdi-store-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
            },
            component: RouteWrapper,
            children: [
              {
                // Client Location Sources (LF, Dealers)
                path: '/clients/locations/sources',
                meta: {
                  title: 'air sources',
                  icon: 'mdi-cloud-outline',
                  authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                },
                component: RouteWrapper,
                children: [
                  {
                    // Client Location Sources Certificates (LF, Dealers)
                    path: '/clients/locations/sources/certificates',
                    name: 'certificates',
                    meta: {
                      title: 'certificates',
                      icon: 'mdi-certificate-outline',
                      authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                    },
                    component: () => import('@/views/lols/Certificates.vue')
                  },

                  {
                    // Client Location Sources Schedule (LF, Dealers)
                    path: '/clients/locations/sources/schedule',
                    name: 'schedule',
                    meta: {
                      title: 'schedule',
                      icon: 'mdi-calendar-month-outline',
                      authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
                    },
                    component: () => import('@/views/lols/Schedule.vue')
                  },
                ]
              }
            ]
          }
        ]
      },

      {
        // Users (LF, Dealers)
        path: '/users',
        name: 'users',
        meta: {
          title: 'users',
          icon: 'mdi-account-group-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
        },
        component: () => import('@/views/companies/Users.vue')
      },

      {
        // User Approvals (LF)
        path: '/userapproval',
        name: 'user approval',
        meta: {
          title: 'user approval',
          icon: 'mdi-account-check-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
        },
        component: () => import('@/views/companies/UserApprovals.vue')
      },

      {
        // Users (LF)
        path: '/users',
        meta: {
          title: 'users',
          icon: 'mdi-account-group-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING'],
          hiddenInMenu: true
        },
        component: RouteWrapper,
        children: [
          {
            // User Approvals (LF)
            path: '/users/approvals',
            name: 'user approvals',
            meta: {
              title: 'user approvals',
              icon: 'mdi-account-group-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
            },
            component: () => import('@/views/companies/UserApprovals.vue')
          },
        ]
      },

      {
        // Lols Root (LF, Dealers)
        path: '/lols',
        name: 'lols',
        meta: {
          title: 'lols',
          icon: 'mdi-tablet-cellphone',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
        },
        component: () => import('@/views/lols/Lols.vue')
      },

      {
        // Lols (LF, Dealers)
        path: '/lols',
        meta: {
          title: 'lols',
          icon: 'mdi-tablet-cellphone',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN'],
          hiddenInMenu: true
        },
        component: RouteWrapper,
        children: [
          {
            // Lol Certificates (LF, Dealer)
            path: '/lols/certificates',
            name: 'certificates',
            meta: {
              title: 'certificates',
              icon: 'mdi-certificate-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN']
            },
            component: () => import('@/views/lols/Certificates.vue')
          },

          {
            // Lol Calibrations (LF, Dealer)
            path: '/lols/calibrations',
            name: 'calibrations',
            meta: {
              title: 'calibrations',
              icon: 'mdi-certificate-outline',
              authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
            },
            component: () => import('@/views/lols/Calibrations.vue')
          }
        ]
      },

      {
        // Units Root (LF, Dealers)
        path: '/units',
        name: 'units',
        meta: {
          title: 'units',
          icon: 'mdi-briefcase-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
        },
        component: () => import('@/views/lols/Units.vue')
      },

      {
        // Units Root (LF, Dealers)
        path: '/calibrations',
        name: 'calibrations',
        meta: {
          title: 'calibrations',
          icon: 'mdi-tools',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING']
        },
        component: () => import('@/views/lols/Calibrations.vue')
      },

      {
        // Certificates (Dealers, Clients)
        path: '/certificates',
        name: 'certificates',
        meta: {
          title: 'certificates',
          icon: 'mdi-certificate-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN', 'ROLE_CLIENT']
        },
        component: () => import('@/views/lols/Certificates.vue')
      },

      {
        // Certificate Review (LF)
        path: '/certreview',
        name: 'certreview',
        meta: {
          title: 'certificate review',
          icon: 'mdi-text-box-check-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING'],
        },
        component: () => import('@/views/lols/CertReview.vue')
      },

      {
        // Schedule (Dealers, Clients)
        path: '/schedule',
        name: 'schedule',
        meta: {
          title: 'schedule',
          icon: 'mdi-calendar-month-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN', 'ROLE_CLIENT']
        },
        component: () => import('@/views/lols/Schedule.vue')
      },

      {
        // Billing (LF)
        path: '/billing',
        name: 'billing',
        meta: {
          title: 'billing',
          icon: 'mdi-currency-usd',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN'],
        },
        component: () => import('@/views/companies/Billing.vue')
      },

      {
        // Standards (LF)
        path: '/standards',
        name: 'standards',
        meta: {
          title: 'standards',
          icon: 'mdi-beaker-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING'],
        },
        component: () => import('@/views/lols/Standards.vue')
      },

      {
        // Feedback (LF)
        path: '/feedback',
        name: 'feedback',
        meta: {
          title: 'feedback',
          icon: 'mdi-message-text-outline',
          authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING'],
        },
        component: () => import('@/views/support/Feedback.vue')
      },

      // {
      //   // Support (LF, Dealers, Clients)
      //   path: '/support',
      //   name: 'support',
      //   meta: {
      //     title: 'support',
      //     icon: 'mdi-face-agent',
      //     authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN', 'ROLE_CLIENT']
      //   },
      //   component: () => import('@/views/support/Support.vue'),
      // },

      // {
      //   // Support (LF, Dealers, Clients)
      //   path: '/support',
      //   name: 'support',
      //   meta: {
      //     title: 'support',
      //     icon: 'mdi-face-agent',
      //     authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN', 'ROLE_CLIENT'],
      //     hiddenInMenu: true
      //   },
      //   component: RouteWrapper,
      //   children: [
      //     {
      //       // Training (LF, Dealers, Clients)
      //       path: '/support/training',
      //       name: 'training',
      //       meta: {
      //         title: 'training',
      //         icon: 'mdi-school-outline',
      //         authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN', 'ROLE_CLIENT']
      //       },
      //       component: () => import('@/views/support/Training.vue')
      //     },

      //     {
      //       // Supplies (LF, Dealers, Clients)
      //       path: '/support/supplies',
      //       name: 'supplies',
      //       meta: {
      //         title: 'supplies',
      //         icon: 'mdi-shopping-outline',
      //         authorize: ['ROLE_LFADMIN', 'ROLE_LFTECH', 'ROLE_LFBILLING', 'ROLE_DEALERADMIN', 'ROLE_CLIENT']
      //       },
      //       component: () => import('@/views/support/Supplies.vue')
      //     }
      //   ]
      // },

      {
        //Access Denied
        path: '/403',
        meta: {
          title: 'access denied',
          hiddenInMenu: true
        },
        name: 'forbidden',
        component: () => import('@/views/error/Deny.vue')
      },
    ]
  }
]
